import { motion } from 'framer-motion'

export default function VisibleBackground() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Large animated circles */}
      {Array.from({ length: 4 }, (_, i) => (
        <motion.div
          key={`circle-${i}`}
          className="absolute rounded-full border-2 border-green-400/60"
          style={{
            width: `${120 + i * 80}px`,
            height: `${120 + i * 80}px`,
            left: `${10 + i * 20}%`,
            top: `${10 + i * 20}%`
          }}
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.4, 0.8, 0.4],
            rotate: [0, 180, 360]
          }}
          transition={{
            duration: 8 + i * 2,
            repeat: Infinity,
            ease: "linear"
          }}
        />
      ))}

      {/* Animated squares */}
      {Array.from({ length: 3 }, (_, i) => (
        <motion.div
          key={`square-${i}`}
          className="absolute border-2 border-green-400/50"
          style={{
            width: `${80 + i * 40}px`,
            height: `${80 + i * 40}px`,
            left: `${60 + i * 15}%`,
            top: `${50 + i * 20}%`
          }}
          animate={{
            rotate: [0, 90, 180, 270, 360],
            opacity: [0.3, 0.7, 0.3],
            scale: [1, 1.2, 1]
          }}
          transition={{
            duration: 10 + i * 2,
            repeat: Infinity,
            ease: "linear"
          }}
        />
      ))}

      {/* Bright floating dots */}
      {Array.from({ length: 25 }, (_, i) => (
        <motion.div
          key={`dot-${i}`}
          className="absolute w-3 h-3 bg-green-400/80 rounded-full"
          style={{
            left: `${Math.random() * 90 + 5}%`,
            top: `${Math.random() * 90 + 5}%`
          }}
          animate={{
            y: [0, -50, 0],
            opacity: [0.5, 1, 0.5],
            scale: [1, 1.3, 1]
          }}
          transition={{
            duration: 3 + Math.random() * 2,
            delay: Math.random() * 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      ))}

      {/* Animated lines */}
      {Array.from({ length: 6 }, (_, i) => (
        <motion.div
          key={`line-${i}`}
          className="absolute h-0.5 bg-gradient-to-r from-transparent via-green-400/70 to-transparent"
          style={{
            width: `${250 + i * 30}px`,
            left: `${Math.random() * 70}%`,
            top: `${15 + i * 12}%`
          }}
          animate={{
            opacity: [0.3, 0.8, 0.3],
            scaleX: [0.7, 1.3, 0.7]
          }}
          transition={{
            duration: 6 + i * 1,
            delay: i * 0.3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      ))}

      {/* Pulsing orbs */}
      {Array.from({ length: 8 }, (_, i) => (
        <motion.div
          key={`orb-${i}`}
          className="absolute w-4 h-4 bg-green-400/60 rounded-full"
          style={{
            left: `${Math.random() * 80 + 10}%`,
            top: `${Math.random() * 80 + 10}%`
          }}
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.4, 0.9, 0.4]
          }}
          transition={{
            duration: 4 + Math.random() * 2,
            delay: Math.random() * 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  )
}